import ComputersIcon from 'assets/icons/computers.svg';
import ServersIcon from 'assets/icons/servers.svg';
import CloudIcon from 'assets/icons/cloud.svg';
import getListWithId from 'utils/getListWithId';

import { Item } from './StaticPageFirstSection.types';
import messages from './StaticPageFirstSection.messages';

export const firstSectionItems: Item[] = getListWithId([
  {
    description: messages.item1,
    icon: ComputersIcon,
  },
  {
    description: messages.item2,
    icon: ServersIcon,
  },
  {
    description: messages.item3,
    icon: CloudIcon,
  },
]);
